/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { FileStoreService } from 'apps/digital-asset-management/src/Services/file-store';
import { create } from 'zustand';

export interface FileStoreServiceStore {
  fileStoreService: FileStoreService | null;
  updateFileStoreService: (newValue: FileStoreService | null) => void;
}

export const useFileStoreServiceStore = create<FileStoreServiceStore>()((set) => ({
  fileStoreService: null,
  updateFileStoreService: (newValue: FileStoreService | null): void => {
    set({ fileStoreService: newValue });
  },
}));
